import { Output, EventEmitter } from "@angular/core";
import { PresentationOption } from "./../../vo/presentation-option";
import { Modal } from "ngx-modialog-7/plugins/bootstrap";
import { Overlay } from "ngx-modialog-7";
import { CourseContextModelService } from "./../../models/course-context-model.service";
import {
	Component,
	OnInit,
	Input,
	SimpleChanges,
	ViewContainerRef,
} from "@angular/core";
import { CourseTimerService } from "../../../services/course-timer.service";
import { Subscription } from "rxjs";
import { UtilityScripts } from "../../../helpers/utility-scripts";
import { AppServices } from "app/app.services";
import { ApplicationModel } from "app/core/models/application.model";
import { ModalPopupService } from "app/services/modal-popup.service";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { OrientationModelService } from "app/core/models/orientation-model.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
@Component({
	selector: "app-app-page-header",
	templateUrl: "./app-page-header.component.html",
	styleUrls: ["./app-page-header.component.scss"],
})
export class AppPageHeaderComponent implements OnInit {
	@Input() curPageNum: number;
	@Input() totalPages: number;
	@Input() totalPagesInCourse: number;

	private percentComplete: string = "";
	private presentationModes: PresentationOption[];
	public pModeOpen: boolean;
	public courseTime: string = "0:00:00";
	public bShowCourseTime: boolean = false;
	private courseTimeSubscription: Subscription;
	private courseCompletedSubscription: Subscription;
	private isCourseCompleted = false;
	private percentVal = 0;

	@Output() presMode: EventEmitter<string> = new EventEmitter();

	constructor(
		private courseContextModelService: CourseContextModelService,
		private courseTimerService: CourseTimerService,
		private appServices: AppServices,
		private modalPopupService: ModalPopupService,
		private screenController: ScreenControllerService,
		public orientationModel: OrientationModelService
	) {
		this.pModeOpen = false;
		this.presentationModes = courseContextModelService.presentationModes;
		console.log("|||||||||||||||||||||||||||||||||||||||||||||||||||||");
		console.log(courseContextModelService.presentationModes);
		console.log("|||||||||||||||||||||||||||||||||||||||||||||||||||||");
		this.courseTimeSubscription = this.courseTimerService.notifier.subscribe(
			(data) => {
				if (data.type == "demo") {
					this.handleCourseTime(data.totalTime);
				} else if (data == "complete") {
					if (ApplicationModel.instance.bLastPageReached) {
						// let popupdata: any = {
						//   size: 'lg',
						//   showClose: true,
						//   buttonLabel: this.screenController.descriptorModel.getDescriptorTextById('close_str'),
						//   title: this.screenController.descriptorModel.getDescriptorTextById('timerSummaryHeader'),
						//   bodyText: this.screenController.descriptorModel.getDescriptorTextById('timerMinMetBody')
						// };
						// this.modalPopupService.closePopup();
						// this.modalPopupService.openPopup(popupdata);
					}
				} else if (data.totalTime) {
					this.handleCourseTime(data.totalTime);
				} else if (data.available) {
					this.bShowCourseTime = data.available;
				}
			}
		);
		this.courseCompletedSubscription = appServices.courseCompleted$.subscribe(
			(event) => this.courseCompletedHandler()
		);
	}

	ngOnInit() {}

	ngOnChanges(simplechanges: SimpleChanges) {
		this.updateProgress();
		this.updatePercentVal();
		this.presentationModes = this.courseContextModelService.presentationModes;
	}

	private courseCompletedHandler() {
		this.isCourseCompleted = true;
		this.updateProgress();
		this.updatePercentVal();
	}

	private handleCourseTime(totalTime) {
		this.courseTime = UtilityScripts.getClockFormat(totalTime);
	}

	private updateProgress() {
		let percentage;
		if (
			this.isCourseCompleted ||
			ApplicationModel.instance.mode == "demo" ||
			TrackingManager.instance.trackingVO.lessonStatus == "p" ||
			TrackingManager.instance.trackingVO.lessonStatus == "c"
		)
			this.percentComplete = "100%";
		else if (this.curPageNum == this.totalPagesInCourse - 1)
			this.percentComplete = "99%";
		else {
			percentage = Math.floor(
				(this.curPageNum / this.totalPagesInCourse) * 100
			);
			this.percentComplete = percentage + "%";
			if (percentage > 99) {
				this.percentComplete = "99%";
			}
		}
	}

	public get percentCompleteVal(): string {
		return this.percentComplete;
	}

	private updatePercentVal() {
		if (
			this.isCourseCompleted ||
			ApplicationModel.instance.mode == "demo" ||
			TrackingManager.instance.trackingVO.lessonStatus == "p" ||
			TrackingManager.instance.trackingVO.lessonStatus == "c"
		)
			this.percentVal = 100;
		else if (this.curPageNum == this.totalPagesInCourse - 1)
			this.percentVal = 99;
		else {
			this.percentVal = Math.ceil(
				(this.curPageNum / this.totalPagesInCourse) * 100
			);
			if (this.percentVal > 99) {
				this.percentVal = 99;
			}
		}
	}

	public get percentProgressVal(): number {
		return this.percentVal;
	}

	public get currentModuleTitle(): string {
		return this.courseContextModelService.currentModuleTitle();
	}

	public presentationClick(event) {
		this.pModeOpen = !this.pModeOpen;
	}

	public get presentationModeOptions(): PresentationOption[] {
		return this.presentationModes;
	}

	public get selectedPresentationMode(): PresentationOption {
		return this.courseContextModelService.selectedPresentationMode;
	}

	public modeSelect(mode: string) {
		this.presMode.emit(mode);
		this.pModeOpen = false;
	}

	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}
}
